<template>
	<div class="productcenter">
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="navBar clearfix">
					<div class="path">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  	<el-breadcrumb-item>产品中心</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="itemBtn" @click="showItem()"><i class="el-icon-menu"></i></div>
				</div>
				<!--内容-->
				<div class="content">
					<div class="itemList" @click="hideItem()" v-if="showBox">
						<div class="content-left">
							<el-col style="border: 1px solid #dfdfdf;">
								<el-menu
								default-active="2"
								class="el-menu-vertical-demo"
								:default-openeds="openeds"
								@open="handleOpen"
								@close="handleClose">
									<div v-for="(item,index) in navList" :key="index">
										<el-submenu v-if="item.children" :index="item.id">
											<template slot="title">
												<span @click="getData(item.id)" style="width:100%;display:block">{{item.name}}</span>
											</template>
											<el-menu-item v-for="child in item.children" :index="item.id+'-'+child.id">
												<span @click="getData(child.id)" style="width:100%;display:block">{{child.name}}</span>
											</el-menu-item>
										</el-submenu>
										<el-menu-item v-if="!item.children" :index="item.id">
											<span @click="getData(item.id)" slot="title">{{item.name}}</span>
										</el-menu-item>
									</div>
								</el-menu>
							</el-col>
						</div>
					</div>
					<div class="content-right">
						<ul>
							<li 
								v-for="(product,index) in listData" 
								@click="gotoDetail(product.id)">
								<img :src="product.default_img"/>
								<p>{{product.name}}</p>
							</li>
						</ul>
						<div class="pages">
							<el-pagination
					            @current-change="handleCurrentChange"
								background
								layout="prev, pager, next"
								v-if="total>1?true:false"
								:total="total"
								pagesize="9"
								style="float:right">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
	<div style="clear:both;"></div>
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		id:'',
		data(){
			return{
				msg:'productcenter',
				activeNames: ['1','2','3','4','5'],
				currentPage1:1,
				navList:[],
				listData:[],
				total:1,
				pagesize:2,
				currentPage:1,
				banner:'',
				openeds:[],
				showBox:false
			}
		},
		methods: {
			handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                this.getList(this.id);
	        },
	        handleOpen(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClose(key, keyPath) {
		        console.log(key, keyPath);
		    },
			gotoDetail(id){
				this.$router.push({
							path:'/ProDetail',
							query: {
				          		id:id,
				          	}
				        })
			},
			getData(id){
				this.currentPage=1;
				this.getList(id);
			},
			getItemList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.productItemApi,
					data: {}
				})
				.then((res) => {
					this.navList = res.data.data;
					var arr = res.data.data[0];
					var id = this.$route.params.id;
					for (var i = 0; i < this.navList.length; i++) {
						this.openeds.push(this.navList[i].id);
					}
					console.log(id);
					if(!id){
						this.getList(0);
					}else{
						this.getList(id);
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getList(id){
				this.axios({
					method: 'get',
					url: this.GLOBAL.productListApi+id+/page/+this.currentPage,
					data: {}
				})
				.then((res) => {
					this.listData = res.data.data;
					this.total = parseInt(res.data.total);
					this.id = id;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'5',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner5;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			showItem(){
				this.showBox = true;
			},
			hideItem(){
				this.showBox = false;
			}
		},
		created(){
			this.getItemList();
			this.getBanner();
		}
	}
	
	
	
	

</script>

<style lang="less" scoped="scoped">
@import url("../../../styles/main.less");
.productcenter{
	.img{
		width:100%;
		overflow:hidden;
		position:relative;
		.height(300);
		img{
			width: 150%;
			height: 100%;
			position:absolute;
			left:-20%;
		}
	}
	.container{
		.padding-left(20);
		.padding-right(20);
		.navBar{
			width:100%;
			.margin-top(20);
			.margin-bottom(20);
			.path{
				width:90%;
				float:left;
				span{
					color: #00A0FF;
					.line-height(80);
				}
			}
			.itemBtn{
				width:10%;
				float:right;
				text-align:right;
				.font-size(60);
				color:#999;
			}
		}
		.content{
			.margin-top(50);
			.margin-bottom(50);
			position:relative;
			.itemList{
				width:100%;
				background:rgba(0,0,0,0.7);
				position:fixed;
				top: 0;
    			left: 0;
    			height:100%;
    			z-index:666;
				.content-left{
					position:fixed;
					display: inline-block;
					width: 50%;
					border-box:box-sizing;
					.font-size(20);
					top:0;
					right:0;
					z-index:999;
					height:100%;
					box-shadow:0 0 20px #444;
					p{
						width: 100%;
						.height(40);
						text-align: left;
						.line-height(40);
						.padding-left(40);
						.font-size(20);
						background: #229dfe;
						color: #fff;
					}
					.mosttitle{
						.font-size(24);
						.margin-left(15);
					}
					.clicklist{
						.font-size(20);
						.padding-left(20);
						.margin-top(5);
						.margin-left(5);
						cursor: pointer;
						.disc{
								display: inline-block;
								.width(5) ;
								.height(5);
								background: #146BFF;
								border-radius: 50%;
								.margin-right(10);
								.margin-bottom(3);
							}
					}
					
				}
			}
			
			.content-right{
				display: inline-block;
				width: 100%;
				ul{
					display: flex;
					flex-wrap: wrap;
					justify-content: flex-start;
					li{
						width:32%;
						.border-radius(10);
						overflow:hidden;
						cursor:pointer;
						.margin-bottom(25);
						box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
						margin:calc(4%/6);
						img{
							width:100%;
							display:block;
							.padding(20,20,20,20)
						}
						p{
							.padding(10,10,10,10);
							text-align:center;
							.font-size(24);
							overflow:hidden;
							white-space:nowrap;
							text-overflow:ellipsis;
							background:#00A0FF;
							color:#fff;
						}
					}
				}
			}
		}
	}
	.el-menu{
		border:0px;
	}
	.el-submenu .el-menu-item{
		width:100%;
	}
	.show{
		display:inline-block !important;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/pages/ProductCenter/ProductCenter.vue